import { clsx } from "clsx"

// Функция для объединения CSS классов
export function cn(...inputs) {
  return clsx(inputs)
} 